// Without backend imports, so that it can be used in the portal
import { CurrencyEnum } from "../types";

// ISO 4217 minor unit exponent, i.e. number of decimals of the smallest currency unit
export const CURRENCY_EXPONENT: Record<CurrencyEnum, number> = {
    AUD: 2,
    BRL: 2,
    CAD: 2,
    CHF: 2,
    CNY: 2,
    DKK: 2,
    EUR: 2,
    GBP: 2,
    HKD: 2,
    ILS: 2,
    INR: 2,
    ISK: 0,
    JPY: 0,
    KRW: 0,
    MXN: 2,
    NOK: 2,
    NZD: 2,
    RUB: 2,
    SEK: 2,
    SGD: 2,
    TRY: 2,
    USD: 2,
    ZAR: 2
};
